/**
 * useEscape — закрытие по клавише Escape.
 *
 * ⚠️ Слушаем keyup, а не keydown: если Escape гасится на keydown, браузерный
 * confirm()/нативный диалог, открытый следом, получает «залипший» keydown и
 * закрывается сам (см. feedback_confirm_on_keyup).
 *
 * Колбэк держим в ref — иначе каждый рендер родителя переподписывал бы слушатель.
 *
 *   useEscape(open, () => setOpen(false));
 */
import { useEffect, useRef } from 'react';

export default function useEscape(active, onEscape) {
  const cbRef = useRef(onEscape);
  useEffect(() => { cbRef.current = onEscape; }, [onEscape]);

  useEffect(() => {
    if (!active) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') cbRef.current?.(e); };
    document.addEventListener('keyup', onKey);
    return () => document.removeEventListener('keyup', onKey);
  }, [active]);
}
